import { CodeSystem } from "@intocare/datatypes/lib/code-system";

export const MEASURE_TYPE = {
	name: "MEASURE_TYPE",
	concept: {
		CONTACT_PRECAUTION_PROCEDURE: {
			display: {
				"nl-BE": "Contactisolatie",
				"fr-BE": "Isolement de contact",
			},
			comment: "SNOMED: 170499009 | Isolation of infection contact (procedure)",
		},
		DROPLET_PRECAUTION_PROCEDURE: {
			display: {
				"nl-BE": "Druppelisolatie",
				"fr-BE": "Isolement gouttelettes",
			},
			comment: "SNOMED: 409525007 | Respiratory secretion precautions (procedure)",
		},
		AIRBORNE_PRECAUTION_PROCEDURE: {
			display: {
				"nl-BE": "Aerogene isolatie",
				"fr-BE": "Isolement aérien",
			},
			comment: "SNOMED: 409524006 | Airborne precautions (procedure)",
		},
		STRICT_MEASURE: {
			display: {
				"nl-BE": "Strikte isolatie",
				"fr-BE": "Isolement strict",
			},
		},
		PROTECTION_PROCEDURE: {
			display: {
				"nl-BE": "Beschermende isolatie",
				"fr-BE": "Isolement protecteur",
			},
			comment: "SNOMED: 225424005 | Protection procedure (procedure)",
		},
	},
} as const satisfies CodeSystem;
